import { render, staticRenderFns } from "./nines.vue?vue&type=template&id=a20c80ea&scoped=true&"
import script from "./nines.vue?vue&type=script&lang=js&"
export * from "./nines.vue?vue&type=script&lang=js&"
import style0 from "./nines.vue?vue&type=style&index=0&id=a20c80ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20c80ea",
  null
  
)

/* custom blocks */
import block0 from "./nines.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CaseIntro: require('/app/components/case/intro.vue').default,CaseContent: require('/app/components/case/content.vue').default,CaseCta: require('/app/components/case/cta.vue').default,CaseRelated: require('/app/components/case/related.vue').default})
